import React from 'react';
import {getPrice} from "../util/price";

import SummaryItem from './SummaryItem.jsx';
import {personBgColors} from "./BookingForm.jsx";

class BookingSummary extends React.Component {

    addToSummary(summary, item) {
        summary[item.id] = {};
        summary[item.id].count = 1;
        summary[item.id].title = item.title;
        summary[item.id].price = item.price;
        summary[item.id].salesPrice = item.sales_price;
        summary[item.id].isOnSale = item.is_on_sale;
        summary[item.id].extras = [];

        if (item.extras) {
            item.extras.forEach((extra) => {
                if (extra.checked) {
                    summary[item.id].extras.push(extra);
                }
            })
        }
    }


    summaryList(person = null) {
        let summary = [];

        this.props.services.forEach((item) => {
            if (person === null) {
                this.addToSummary(summary, item);
            } else if ((item.person || 1) === person) {
                this.addToSummary(summary, item);
            }
        });

        if (Object.keys(summary).length <= 0) {
            return (
                <div className="booking-form__summary-item">
                    <div className="flex">
                        <div className="flex-1 opacity-25">Nothing assigned yet</div>
                    </div>
                </div>
            );
        }

        return Object.keys(summary).map(function(key, index){
            return (
                <SummaryItem key={index} item={summary[key]} />
            )
        });
    }

    getPrefix(key) {
        const cx = 'rounded-full text-center mr-2 text-white inline-block w-5 h-5 leading-normal align-middle text-sm ' + personBgColors[key];
        return <div className={cx}>{key + 1}</div>
    }

    summaryGroup() {
        if (this.props.clients <= 1) {
            return this.summaryList();
        } else {
            const range = Array.apply(null, Array(this.props.clients)).map(function (_, i) {return i;});
            return range.map((key) => {
                return (
                    <div className='mt-4' key={key}>
                        <div className='text-sm font-semibold'>{this.getPrefix(key)} Person {key +1}</div>
                        {this.summaryList(key + 1)}
                    </div>
                );
            })
        }
    }

    renderPrivacyPolicyLine() {
        return (
            <span>
                { trans.by_clicking_make_appointment_agree }
                <a href={window.WPURLS.privacyPolicyPage.url} target="_blank">
                    {window.WPURLS.privacyPolicyPage.title}
                </a>
            </span>
        )
    }

    render() {
        return (
            <div className="booking-form__block booking-form__block--summary">
                <h2 className="booking-form__title">{trans.summary}</h2>

                { this.summaryGroup() }

                {/* <div className="booking-form__summary-item clients-count">
                    <div className="flex">
                        <div className="flex-1">{trans.clients}</div>
                        <ul>
                            <li></li>
                            <li>x{this.props.clients}</li>
                        </ul>
                    </div>
                </div> */}

                <div className="booking-form__total text-right">
                    {trans.total}: {trans.currency_prepend}{getPrice(this.props.total)} {trans.currency_append}
                </div>
                <button type="submit" className="booking-form__cta btn btn-red">
                    {trans.make_appointment}
                </button>
                <div className="booking-form__legal">
                    {this.renderPrivacyPolicyLine()}
                </div>
            </div>
        )
    }
}

export default BookingSummary;



// WEBPACK FOOTER //
// ./scripts/components/BookingSummary.jsx